import {FATCA_CRS_CONFIRM_KEYS} from '@sollapay/enums';

import type {SupplementaryDeclarationValues} from '@/features/trust-accounts/fatca-crs/components';
import type {FatcaCrsDeclarationDTO} from '@sollapay/types';

/** Stable empty defaults for a new supplementary declaration form. */
export const EMPTY_SUPPLEMENTARY_FORM_VALUES: SupplementaryDeclarationValues = {
  declarationValues: {
    [FATCA_CRS_CONFIRM_KEYS.BENEFICIARIES_UNCHANGED]: false,
    [FATCA_CRS_CONFIRM_KEYS.UPDATE_COMMITMENT]: false,
    [FATCA_CRS_CONFIRM_KEYS.SIGNATURE]: false
  }
};

/** Seed a form from an existing (already-signed) supplementary declaration. */
export const toFatcaCrsSupplementaryFormValues = (
  declaration: FatcaCrsDeclarationDTO | null | undefined
): SupplementaryDeclarationValues => {
  if (!declaration) {
    return EMPTY_SUPPLEMENTARY_FORM_VALUES;
  }
  const dv = declaration.declarationValues;
  return {
    declarationValues: {
      [FATCA_CRS_CONFIRM_KEYS.BENEFICIARIES_UNCHANGED]:
        dv[FATCA_CRS_CONFIRM_KEYS.BENEFICIARIES_UNCHANGED] === true,
      [FATCA_CRS_CONFIRM_KEYS.UPDATE_COMMITMENT]:
        dv[FATCA_CRS_CONFIRM_KEYS.UPDATE_COMMITMENT] === true,
      [FATCA_CRS_CONFIRM_KEYS.SIGNATURE]: dv[FATCA_CRS_CONFIRM_KEYS.SIGNATURE] === true
    }
  };
};

/** The form values shape is identical to the sign payload — pass through as-is. */
export const toSignSupplementaryFatcaCrsPayload = (
  values: SupplementaryDeclarationValues
): SupplementaryDeclarationValues => values;
